import { useSuspenseQuery } from "@tanstack/react-query";
import api from "api/index";


export const useQueryStart = () => {
	return useSuspenseQuery({
		queryKey: ["start"],
		queryFn: api.start.get,
		staleTime: Infinity
	});
};